type UploadProgressBarProps = {
  percent: number;
};

export default function UploadProgressBar({ percent }: UploadProgressBarProps) {
  return (
    <div className="bg-indigo-50 px-4 sm:px-6 lg:px-8 py-2">
      <div className="flex items-center gap-3">
        <div className="flex-1 bg-indigo-200 rounded-full h-1.5">
          <div
            className="bg-indigo-500 h-1.5 rounded-full transition-all duration-300"
            style={{ width: `${percent}%` }}
          />
        </div>
        <span className="text-xs text-indigo-600 font-medium whitespace-nowrap">
          {percent}%
        </span>
      </div>
    </div>
  );
}
